var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderNavToggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 1",
    transform: "translate(1.955 3.501)",
    style: {
      stroke: "#7833ba",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.5px",
      fill: "none"
    },
    d: "M0 0h20.016"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 2",
    transform: "translate(1.955 12.121)",
    style: {
      stroke: "#7833ba",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.5px",
      fill: "none"
    },
    d: "M0 0h20.016"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 3",
    transform: "translate(1.955 20.714)",
    style: {
      stroke: "#7833ba",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.5px",
      fill: "none"
    },
    d: "M0 0h20.089"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderNavToggle);
export default __webpack_public_path__ + "static/media/header_nav_toggle.8e03e4ccb66ad195eccc70d1c387b900.svg";
export { ForwardRef as ReactComponent };